import { render, staticRenderFns } from "./rowSeat.vue?vue&type=template&id=51048203&"
import script from "./rowSeat.vue?vue&type=script&lang=js&"
export * from "./rowSeat.vue?vue&type=script&lang=js&"
import style0 from "./rowSeat.vue?vue&type=style&index=0&id=51048203&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports